import { 
  Gallery, 
} from '../types/gallery';
import { appApi } from '../../../store/app.api';
import { appEndpoint } from '../../../store/app.endpoint';
import { CommandRequest } from '../../../libs/auth/utilities/command-request';

export const galleriesApi = appApi.injectEndpoints({
  endpoints: (build) => ({
    getGalleries: build.query<any, { page?: number; per_page?: number }>({
      query: (params) => ({
        url: appEndpoint.getGalleries,
        method: 'get',
        params,
      }),
      providesTags: ['Galleries'],
    }),
    addGallery: build.mutation<any, CommandRequest>({
      query: (data) => ({
        url: appEndpoint.addGallery,
        method: 'post',
        data: data.body
      }),
      invalidatesTags: (result) => (result ? ["Galleries"] : []),
    }),

    updateGallery: build.mutation<any, CommandRequest>({
      query: (data) => ({
        url: `${appEndpoint.updateGallery}/${data.id}?_method=put`,
        method: 'post',
        data: data.body
      }),
      invalidatesTags: (result) => (result ? ["Galleries"] : []),
    }),
    getGalleryById: build.query<any, string>({
      query: (id) => ({
        url: `${appEndpoint.getGalleries}/${id}`,
        method: 'get',
      }),
      providesTags: (result, error, id) => [{ type: 'Galleries', id }],
    }),

    deleteGallery: build.mutation<void, string>({
      query: (id) => ({
        url: `${appEndpoint.deleteGallery}/${id}`,
        method: 'delete',
      }),
      invalidatesTags: ['Galleries'],
    }),

    getCategories: build.query<any, void>({
      query: () => ({
        url: appEndpoint.getCategories,
        method: 'get',
      }),
      providesTags: ['Categories'],
    }),
    addCategory: build.mutation<any, CommandRequest>({
      query: (data) => ({
        url: appEndpoint.getCategories,
        method: 'post',
        data: data.body,
      }),
      invalidatesTags: (result) => (result ? ["Categories"] : []),
    }),
    updateCategory: build.mutation<any, CommandRequest>({
      query: (data) => ({
        url: `${appEndpoint.getCategories}/${data.id}?_method=put`,
        method: 'post',
        data: data.body,
      }),
      invalidatesTags: (result) => (result ? ["Categories"] : []),
    }),
    deleteCategory: build.mutation<void, string>({
      query: (id) => ({
        url: `${appEndpoint.getCategories}/${id}`,
        method: 'delete',
      }),
      invalidatesTags: ['Categories'],
    }),

  }),
  overrideExisting: false,
});

export const {
  useGetGalleriesQuery,
  useDeleteGalleryMutation,
  useAddGalleryMutation,
  useUpdateGalleryMutation,
  useGetGalleryByIdQuery,
  useGetCategoriesQuery,
  useAddCategoryMutation,
  useUpdateCategoryMutation,
  useDeleteCategoryMutation,
} = galleriesApi;
